import React, { useState } from "react";
import { StepHeader } from "../common/StepHeader";
import { InputField } from "../common/InputField";
import { Footer } from "../common/Footer";
import { useStepData } from "../../hooks/useStepData";
import { useFunnelNavigation } from "../../hooks/useFunnelNavigation";

export function EmailCollection({ config }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const { updateStepData } = useStepData(config.field);
  const { nextStep } = useFunnelNavigation();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    setError("");

    if (!value) {
      setIsValidEmail(false);
      setError("Please enter your email address");
      return;
    }

    if (!validateEmail(value)) {
      setIsValidEmail(false);
      setError("Please enter a valid email address");
      return;
    }

    setIsValidEmail(true);
  };

  const handleSubmit = () => {
    if (isValidEmail) {
      // Save email to context
      updateStepData(email);
      // Move to next step
      nextStep();
    }
  };

  return (
    <div className="flex flex-col bg-gray-100">
      <div className="flex-1 px-4">
        <StepHeader
          title={config.title}
          subtitle={config.subtitle}
          className="mb-8"
        />

        <div className="space-y-6">
          <InputField
            value={email}
            type="email"
            onChange={handleEmailChange}
            placeholder="Enter your email"
            error={error}
          />

          {isValidEmail && (
            <Footer onClick={handleSubmit}>
              {config.buttonText || "Submit"}
            </Footer>
          )}
        </div>
      </div>
    </div>
  );
}
